<!--
 * @Description: 人员列表页面
 * @Author: wanqian,gaohc, fengal
 * @Date: 2022-03-16 16:43:52
-->
<template>
   <div class="body" v-loading="loading">
    <el-row style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="7" style="text-align: left">
        <span class="search-title">机构名称：</span>
        <el-select size="small" style="width: 210px" v-model="filterParams.institutionId" filterable clearable 
          placeholder="请输入/选择" 
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					@visible-change="(visible) => 
            commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)">
          <el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-col>
      <el-col :span="5" style="text-align: center">
        <span class="search-title">人员级别：</span>
        <el-select size="small" style="width: 140px" v-model="filterParams.level" clearable filterable 
          placeholder="请选择">
          <el-option v-for="(value, key, index) in levelMap" :key="index" :label="value" :value="key"></el-option>
        </el-select>
      </el-col>
      <el-col :span="5" style="text-align: center">
        <span class="search-title">审核状态：</span>
        <el-select size="small" style="width: 140px" v-model="filterParams.reviewStatus" clearable filterable 
          placeholder="请选择">
          <el-option v-for="(item, index) in reviewStatusList" :key="index" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="7" style="text-align: right">
        <span class="search-title">设备品牌：</span>
        <el-input size="small" style="width: 210px" placeholder="请输入" v-model="filterParams.mobileBrand" clearable>
        </el-input>
			</el-col>
    </el-row>
    <el-row style="margin: 0 40px 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="7" style="text-align: left">
        <span class="search-title">人员信息：</span>
        <el-input size="small" style="width: 210px" placeholder="姓名/手机号/编号" 
          v-model="filterParams.nameOrPhoneOrIdno" clearable>
        </el-input>
      </el-col>
      <el-col :span="5" style="text-align: center">
        <span class="search-title">服务权限：</span>
        <el-select size="small" style="width: 140px" v-model="filterParams.privilege" clearable filterable 
          placeholder="请选择">
          <el-option v-for="(value, key, index) in privilegeMap" :key="index" :label="value" :value="key">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="5" style="text-align: center">
        <span class="search-title">提现账户：</span>
        <el-select size="small" style="width: 140px" v-model="filterParams.memberStatus" clearable filterable 
          placeholder="请选择">
          <el-option v-for="(item, index) in memberStatusList" :key="index" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </el-col>
      <el-col  :span="7" style="text-align: right">
        <el-button size="small" plain type="primary" class="btn-search-w80" 
					style="background: #FEFFFF; color: #3E7EF5;"
          v-if="dataPvgList.includes('ATDN_3_EXPORT')" 
					@click="handleExport">
					<el-image :src="require('@/assets/report/icon-report-export.png')" fit="cover" 
						style="width: 12px; height: 12px; margin-right: 6px; vertical-align: bottom;">
					</el-image>
					导 出
				</el-button>
        <el-button v-if="dataPvgList.includes('ATDN_1_CREATE')" size="small" @click="handleAddAttendant" type="primary" icon="el-icon-plus">新 增</el-button>
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search">搜 索</el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>
    <el-table style="margin: 20px 40px; border: 1px solid #f0f0f0;" :style="tableWidth" ref="table" :data="dataTable" 
      header-cell-class-name="table-header-color" row-key="id">
      <el-table-column prop="institutionText" label="所属机构" min-width="12%" align="left">
        <template slot-scope="scope">{{scope.row.institutionText ? scope.row.institutionText : '- -'}}</template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" min-width="8%" align="left">
        <template slot-scope="scope">
          <div>{{scope.row.name ? scope.row.name : '- -'}}</div>
          <div>{{scope.row.status == 2 || !scope.row.mobile ? '- -' : scope.row.mobile}}</div>
        </template>
      </el-table-column>
       <el-table-column prop="regTime" label="注册时间" sortable min-width="10%" align="left">
          <template slot-scope="scope">{{scope.row.regTime}}</template>
        </el-table-column>
      <el-table-column label="审核状态" min-width="8%" align="left">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 2">- -</span>
          <!-- 0-未审核 1-审核通过 2-审核拒绝 3-撤回 -->
          <span v-else :class="scope.row.reviewStatus == 0 ? 'text-light-gray' : scope.row.reviewStatus == 2 
            ? 'text-red' : ''">
            {{scope.row.reviewStatusText}}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="设备品牌" min-width="10%" align="left">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.status == 2">- -</span>
            <span v-else>{{scope.row.mobileBrand ? scope.row.mobileBrand : '- -'}}</span>
            <div>{{scope.row.mobileModel ? scope.row.mobileModel : '- -'}}</div>
          </div>
          <div></div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="提现账户" min-width="8%" align="left" v-if="showWithdrawAccount">
        <template slot="header">
          <span>提现账户</span>
          <el-popover placement="bottom" title="" width="226" trigger="hover"
            content="护工端可申请开通个人提现账户，开通后服务收入方可提现">
            <span slot="reference">
              <img style="width: 18px; height: 18px; vertical-align: middle; cursor: pointer;" 
                src="@/assets/common/icon-common-question-mark.png" alt="">
            </span>
          </el-popover>
        </template>  
        <template slot-scope="scope">
          <span :style="{'color': scope.row.memberStatus == 1 ? '#606266' : '#FF4646'}">
            {{ scope.row.memberStatusText }}
          </span>
          <div style="color: #888;font-size: 12px;">
            {{scope.row.openLklTime}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="派单权" min-width="8%" align="left">
        <template slot-scope="scope">
          <div :class="(scope.row.reviewStatus != 1 || scope.row.status == 2 || !dataPvgList.includes('ATDN_4_PVG_CHG')) ? 'disclick' : 'canclick'" @click="handleDispatch(scope.row)">
            <div class="dispatch">
              <span>{{scope.row.dispatchStatus ? '有' : '无'}}</span>
              <img src="../../assets/instmng/attendantlist/img-attendant-dispatch.png" alt="">
            </div>
            <div class="dispatch-hsp" v-show="scope.row.dispatchStatus && scope.row.dispatchedHospitalNum">
              {{scope.row.dispatchedHospitalNum}}家医院
            </div>
          </div>
        </template>
        
      </el-table-column>
      <el-table-column label="接单权" min-width="8%" align="left">
        <template slot-scope="scope">
          <div :class="(scope.row.reviewStatus != 1 || scope.row.status == 2 || !dataPvgList.includes('ATDN_4_PVG_CHG')) ? 'disclick' : 'canclick'" @click="handleAccept(scope.row)">
            <div class="dispatch">
              <span>{{scope.row.acceptStatus ? '有' : '无'}}</span>
              <img src="../../assets/instmng/attendantlist/img-attendant-dispatch.png" alt="">
            </div>
            <div class="dispatch-hsp" v-show="scope.row.acceptStatus && scope.row.acceptHospitalNum">
              {{scope.row.acceptHospitalNum}}家医院
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="6%" align="left">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 2" class="span-logout">已注销</span>
          <el-switch v-else v-model="scope.row.status" active-color="#13ce66" :active-value="1" :inactive-value="0" 
            :disabled="scope.row.reviewStatus != 1 || !dataPvgList.includes('ATDN_5_STATUS_CHG')" @change="handleStatusSwitch(scope.$index, scope.row, scope.row.status)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="8%" align="left">
        <template slot-scope="scope" v-if="scope.row.status != 2">
          <el-button @click="handleDetailClick(scope.row)" type="text" size="small">详情</el-button>
          <template v-if="scope.row.reviewStatus != 0">
            <el-divider direction="vertical"></el-divider>
            <el-button v-if="dataPvgList.includes('ATDN_2_UPDATE')" @click="handleEditClick(scope.row)" type="text" size="small">编辑</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
      :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
      layout="total, prev, pager, next, sizes, jumper" :total="totalNumber" />
    </el-row>
    <!-- 人员新增/编辑对话框 -->
     <attendant-form :visible="showAttendantDialog" :operate="operateAttendant" :attendantId="attendantId" 
      :institutionId="filterParams.institutionId" @close-dialog="closeSaveOrUpdateAttendantDialog" />
    <!-- 人员详情对话框 -->
    <attendant-details :visible="showAttendantDetailsDialog" :attendantId="attendantId" 
      @close-dialog="showAttendantDetailsDialog = false" />    
    <!-- 操作派单权限弹框 -->
    <setup-dispatch-pvg :visible="showSetupDispatchPvg" :attendantId="attendantId" :curAttendant="curAttendant" 
      @close-dialog="handleCloseDispatchPvg" @cancel-dispatch="cancleDispatchPvg"/>  
    <!-- 操作接单权限弹框 -->
    <setup-accept-pvg :visible="showSetupAcceptPvg" :attendantId="attendantId"
      @close-dialog="handleCloseAcceptPvg" /> 
    <!-- 人员导出 -->
    <attendant-export :visible="showAttendantExportDialog" :filterParams="filterParams" 
    @close-dialog="showAttendantExportDialog = false" /> 
   </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import Util from '@/global/Util.js'
import AttendantForm from './components/AttendantForm.vue'
import AttendantDetails from './components/AttendantDetailsDialog.vue'
import CancleDispatchPrivilegeDialog from './components/CancleDispatchPrivilegeDialog.vue'
import SetupDispatchPvg from './components/SetupDispatchPvg.vue'
import SetupAcceptPvg from './components/SetupAcceptPvg.vue'
import AttendantExportDialog from './components/AttendantExportDialog.vue'

export default {
  name: 'AttendantList',
  components: {
    'attendant-form': AttendantForm,
    'attendant-details': AttendantDetails,
    'cancle-dispatch-privilege-dialog': CancleDispatchPrivilegeDialog,
    'setup-dispatch-pvg': SetupDispatchPvg,
    'setup-accept-pvg': SetupAcceptPvg,
    'attendant-export': AttendantExportDialog,
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      
      srcInstitutionList: [],
      institutionList: [],
      levelMap: {},
      reviewStatusList: [],
			privilegeMap: {},
      memberStatusList: {},
      loading: false,

			dataTable: [],
      totalNumber: 0,
      attendantId: 0,

      //以下是人员新增/编辑对话框使用
      showAttendantDialog: false,
      operateAttendant: 'add',

      //人员详情对话框使用
      showAttendantDetailsDialog: false,

      // 派单权限操作弹框
      showSetupDispatchPvg: false,
      showSetupAcceptPvg: false,
      curAttendant: {},

      showWithdrawAccount: false,   //是否显示提现账户

      showAttendantExportDialog: false,
    }
  },

	computed: {
    tableWidth() {
      return 'width:' + (this.$root.contentWidth - 80) + 'px';
    },
  },
  
  methods:{
    async initData() {
      await this.getDataPvg4CurRole();
      await this.getFilterDoData();
      await this.listAttendants();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'ATDN'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

		getFilterDoData() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_ATTENDANT_FILTER_DO).then(result => {
          if (result != null) {
            this.rebuildData(result.data);
            //如果从机构跳转过来的携带机构ID
            if (this.$route.params.institutionId) {
              this.$set(this.filterParams, 'institutionId', this.$route.params.institutionId)
            }
            resolve();
          }
        })
      })
		},

    rebuildData(obj) {
      this.showWithdrawAccount = obj.showWithdrawAccount;
      this.institutionList = obj.institutionList;
      this.srcInstitutionList = obj.institutionList;
      this.levelMap = obj.levelMap;
      this.privilegeMap = obj.privilegeMap;
      this.reviewStatusList = this.commonUtil.map2List(obj.reviewStatusMap);
      this.memberStatusList = this.commonUtil.map2List(obj.memberStatusMap);
    },

		listAttendants() {
      return new Promise((resolve) => {
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(this.filterParams,
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
            method: 'GET',
            url: Constant.URL_PAGE_ATTENDANTS,
            param: esParam,
            header: header,
            contentType: this.commonConst.CNTYPE_URLENCODED,
        };

        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataTable = result.data;
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
		},

    queryStatusChange(id, status) {
      let params = {
        id: id,
        status: status
      };
      let header = this.encryptionUtil.signatureParams(params, 
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT', 
        url: Constant.URL_UPDATE_ATTENDANT_STATUS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.listAttendants();
      });
    },

		handleQuery() {
      this.filterParams.page = 1;
      this.listAttendants();
    },

		handleAddAttendant() {
      this.showAttendantDialog = true;
      this.operateAttendant = "add";
      this.attendantId = 0;
    },

		//启用状态改变
    handleStatusSwitch(index, row, val) {
      let item = this.dataTable[index];
      item.status = val == 1 ? 0 : 1;
      let status = val == 1 ? "enable" : "disable";
      let strMessage = val == 1 ? '确认是否启用？' : '确认是否停用？';
      this.$confirm(strMessage, '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.queryStatusChange(row.id, status);
      });
    },

    handleCloseDispatchPvg(refresh) {
      this.showSetupDispatchPvg = false
      if (refresh) this.listAttendants()
    },

    handleCloseAcceptPvg(refresh) {
      this.showSetupAcceptPvg = false
      if (refresh) this.listAttendants()
    },

    // 导出excel
    async handleExport() {
      let param = {...this.filterParams}
      delete param.page
      delete param.pageSize

      this.loading = true;
      await Util.exportExcel(Constant.URL_EXPORT_ATTENDANTS, param)
      this.loading = false;
    },

		//详情
    handleDetailClick(item) {
      this.attendantId = item.id;
      this.showAttendantDetailsDialog = true;
    },

    //编辑
    handleEditClick(item) {
      this.showAttendantDialog = true;
      this.operateAttendant = "edit";
      this.attendantId = item.id;
    },

    async closeSaveOrUpdateAttendantDialog(refresh) {
      this.showAttendantDialog = false;
      if (refresh) await this.listAttendants();
      this.$forceUpdate()
    },

    handleAccept(row) {
      if (row.reviewStatus != 1 || row.status == 2 || !this.dataPvgList.includes('ATDN_4_PVG_CHG')) return
      if (!row.hospitalNum) return this.$message.error('此人所在机构未关联医院，请先关联医院后再设置派单权！')
      this.curAttendant = row
      this.showSetupAcceptPvg = true
      this.attendantId = row.id
    },

    handleDispatch(row) {
      if (row.reviewStatus != 1 || row.status == 2 || !this.dataPvgList.includes('ATDN_4_PVG_CHG')) return
      if (!row.hospitalNum) return this.$message.error('此人所在机构未关联医院，请先关联医院后再设置派单权！')
      this.curAttendant = row
      this.showSetupDispatchPvg = true
      this.attendantId = row.id
    },

    cancleDispatchPvg(row) {
      this.cancelDispatchAttendant = this.curAttendant;
      this.cancelDispatchAttendantId = this.curAttendant.id;
      this.cancleDispatchMessage = row;
      this.showCancleDispatchDialog = true
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listAttendants();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listAttendants();
    },

    countAttendantAge(practiceStartDate) {
      return this.dateUtil.yearsAgoText(practiceStartDate, new Date());
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '机构管理', text2: '人员列表'});
		this.initData();
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
.search-title {
  color: #657180;
  font-size: 14px;
}
.main-line {
  height: 10px;
  background-color: #f2f3f4;
}
.foot-pagination {
  text-align: right;
  right: 40px;
  border: solid 0px;
}
.text-light-gray {
  color: #999999;
}
.text-red {
  color: #FF0909;
}
.span-logout {
  font-size: 14px;
  font-weight: 500;
  color: #FF3C3C;
}
.dispatch {
  display: flex;
  align-items: center;
}
.dispatch img {
  width: 16px;
  height: 18px;
  margin-left: 5px;
}
.dispatch-hsp {
  font-size: 10px;
  color: #8F9399;
}
.disclick {
  cursor: not-allowed;
}
.canclick {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/AttendantList.vue